module.exports = __webpack_public_path__ + "static/img/qrCodeEn-clientBig.dea8c89b.png";